module.exports = __webpack_public_path__ + "img/anhui.4e7feede.png";